function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/customer/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'customerList',
        path: '/ems/customerList',
        meta: {
            title: '客户列表'
        }
    },
    {
        name: 'customerDetail',
        path: '/ems/customerDetail',
        meta: {
            title: '客户信息'
        }
    },
    {
        name: 'customerEditor',
        path: '/ems/customerEditor',
        meta: {
            title: '客户信息'
        }
    },
    {
        name: 'buildingEditor',
        path: '/ems/buildingEditor',
        meta: {
            title: '新增建筑'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/customer.js